// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AsteriskOutlinedSvg from "@fishx/icons-svg/es/asn/AsteriskOutlined";
import FishxIcon from '../components/FishxIcon';

var AsteriskOutlined = function AsteriskOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AsteriskOutlinedSvg
  }));
};

AsteriskOutlined.displayName = 'AsteriskOutlined';
export default React.forwardRef(AsteriskOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AsteriskOutlined.js
// module id = 2030
// module chunks = 0